module.exports = __webpack_public_path__ + "static/media/memberGroupMemberAddedIcon.878b0f68.png";